import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({
  value,
  onClick,
  type = "status", // "status" | "highlighted" | "contacted" | "verified" | "isExtern" | "task"
  children, // Optional: Überschreibt das Label
}) => {
  const getLabel = () => {
    if (children !== undefined) {
      return children;
    }
    switch (type) {
      case "status":
        return value ? "Aktiv" : "Inaktiv";
      case "highlighted":
        return value ? "Ja" : "Nein";
      case "contacted":
        return value ? "Ja" : "Nein";
      case "verified":
        return value ? "Ja" : "Nein";
      case "isExtern":
        return value ? "Ja" : "Nein";
      case "task":
        return value ? "Erledigt" : "Offen";
      default:
        return value ? "Ja" : "Nein";
    }
  };

  const getClassName = () => {
    const baseClass = "status-badge";
    if (type === "status") {
      return `${baseClass} ${value ? "active" : "inactive"}`;
    } else if (type === "highlighted") {
      return `${baseClass} ${value ? "highlighted" : "not-highlighted"}`;
    } else if (type === "contacted") {
      return `${baseClass} ${value ? "contacted" : "not-contacted"}`;
    } else if (type === "verified") {
      return `${baseClass} ${value ? "verified" : "not-verified"}`;
    } else if (type === "isExtern") {
      return `${baseClass} ${value ? "is-extern" : "not-is-extern"}`;
    } else if (type === "task") {
      return `${baseClass} ${value ? "done" : "todo"}`;
    }
    return baseClass;
  };

  return (
    <span className={getClassName()} onClick={onClick}>
      {getLabel()}
    </span>
  );
};

export default StatusBadge;